// App.js
import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeModeProvider } from './context/ThemeModeContext'
import GlobalStyle from './GlobalStyle'
import AppRoutes from './routes'

function App() {
  return (
    <ThemeModeProvider>
      <GlobalStyle />
      <HelmetProvider>
        <AppRoutes />
      </HelmetProvider>
    </ThemeModeProvider>
  )
}

export default App
